module.exports = __webpack_public_path__ + "assets_1773307907123/img/pic_6.13790e82.png";